import React from "react";
import { Dialog } from "@headlessui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import cancelIcon from "../../../assets/images/cancel.png";
import { useLockBodyScroll } from "../../../hooks/useLockBodyScroll";

export default function CaptureImageModal({ isOpen, onClose, images = [] }) {
  useLockBodyScroll(isOpen);
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
    >
      <Dialog.Panel className="relative bg-white rounded-2xl p-4 pt-10 w-[90%] max-w-md shadow-xl flex flex-col items-center">
        {/* Cancel icon INSIDE the modal box, centered at the top */}
        <img
          src={cancelIcon}
          alt="Cancel"
          className="absolute top-2 right-2 w-6 h-6 cursor-pointer hover:scale-105 transition"
          onClick={onClose}
        />

        {/* Image Swiper */}
        <Swiper
          pagination={{ clickable: true }}
          modules={[Pagination]}
          className="w-full h-[400px] rounded-md"
        >
          {images.map((imgSrc, index) => (
            <SwiperSlide key={index}>
              <img
                src={imgSrc}
                alt={`Parcel ${index + 1}`}
                className="w-full h-full object-contain rounded-md"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Dialog.Panel>
    </Dialog>
  );
}
